@if (autAppGuard !== NotAuthenticatedJustLoggedIn) {
  @if (currentUser$ | async; as itemsLogged) {
    @if (itemsLogged?.uid) {
      <div (click)="loggedMenu.toggle($event)" class="header-user-info">
        <p-badge [value]="(acronym$ | async) ?? ''" class="flex" styleClass="border-circle p-badge-header"/>
        <span>{{ userFullName$ | async }}</span>
      </div>
    }

    <p-menu #loggedMenu [model]="(itemsLogged$ | async) ?? []" [popup]="true"></p-menu>
  }
}
